import React from 'react';
import ReactDOM from 'react-dom';
import './ProductAccessories.scss';
import Accessory from './Accessory';

if (!customElements.get('product-accessory')) {
  customElements.define(
    'product-accessory',
    class ProductAccessoryClass extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        setTimeout(() => {
          try {
            let productData = JSON.parse(this.innerText);
            const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
            const element = <Accessory ctx={window.app} el={this} {...Object.fromEntries(props)} product={productData} />;
            ReactDOM.render(element, this);
          } catch (error) {
            console.error(error);
          }
        }, 500);
      }
    }
  );
}

if (!customElements.get('product-accessories')) {
  customElements.define(
    'product-accessories',
    class ProductAccessoriesClass extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        setTimeout(() => {
          this.header = this.querySelector('header');
          this.content = this.querySelector('.accessories_list');
          this.header?.addEventListener('click', this.toggle.bind(this));
          this.header?.addEventListener('keydown', this.toggle.bind(this));
        }, 500);
      }
      toggle(ev) {
        if (ev.code && ev.code != 'Enter') {
          return;
        }
        this.classList.toggle('is-active');
      }
    }
  );
}
